import delux1 from '../images/rooms/Deluxe Room/img1.JPG';
import delux2 from '../images/rooms/Deluxe Room/img2.jpg';
import delux3 from '../images/rooms/Deluxe Room/img3.jpg';

import sa1 from '../images/rooms/Studio Apartment/img1.JPG';
import sa2 from '../images/rooms/Studio Apartment/img2.JPG';
import sa3 from '../images/rooms/Studio Apartment/img3.jpeg';
import sa4 from '../images/rooms/Studio Apartment/img4.jpeg';

import bd1 from '../images/rooms/2 Bedroom-Living Room-Dining/img1.JPG';
import bd2 from '../images/rooms/2 Bedroom-Living Room-Dining/img2.jpeg';
import bd3 from '../images/rooms/2 Bedroom-Living Room-Dining/img3.jpeg';
import bd4 from '../images/rooms/2 Bedroom-Living Room-Dining/img4.jpeg';
import bd5 from '../images/rooms/2 Bedroom-Living Room-Dining/img5.JPG';
import bd6 from '../images/rooms/2 Bedroom-Living Room-Dining/img6.jpg';
import bd7 from '../images/rooms/2 Bedroom-Living Room-Dining/img7.JPG';
import bd8 from '../images/rooms/2 Bedroom-Living Room-Dining/img8.jpg';
import bd9 from '../images/rooms/2 Bedroom-Living Room-Dining/img9.jpg';
import bd10 from '../images/rooms/2 Bedroom-Living Room-Dining/img10.jpg';
import bd11 from '../images/rooms/2 Bedroom-Living Room-Dining/img11.jpeg';
import bd12 from '../images/rooms/2 Bedroom-Living Room-Dining/img12.jpeg';



export const rooms = [

   {
    id: 1,
    title: "Delux Rooms",
    images: [delux1,delux2,delux3],
    tags: ["Single Room","King size bed","Smart TV","Bathtub/shower","Towels","Linens","Tile/Marble floor"]
   },
   {
    id: 2,
    title: "Studio Apartment",
    images: [sa1,sa2,sa3,sa4],
    tags: ["Living Room","Bedroom","Separate Kitchen","Dining","Smart TV","Sofa","Bathtub/shower","Towels","Linens","Tile/Marble floor","Washing machine","Streaming service","Balcony"]
   },
   {
    id: 3,
    title: "2 Bedrooms Apartment",
    images: [bd1,bd2,bd3,bd4,bd5,bd6,bd7,bd8,bd9,bd10,bd11,bd12],
    tags: ["Living Room","2 Bedrooms","Kitchen","Dining","Smart TV","Sofa","Bathtub/shower","Towels","Linens","Tile/Marble floor","Washing machine","Streaming service","Balcony"]
   }
]